import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-site-authentication', {
    lineHeight: '16px',
});

cssRule('.tb-site-authentication .tb-checkbox-label', {
    display: 'inline-block',
});

cssRule('.tb-site-authentication .tb-checkbox-indent', {
    paddingLeft: '21px',
});

cssRule('.tb-site-authentication .tb-enabled-color', {
    color: applyColor(DesignTokens.color.link.inline.default.active, '#15557f'),
    fontWeight: 'bold',
});

cssRule('.tb-site-authentication .tb-status-indicator', {
    display: 'inline-block',
    backgroundColor: applyColor(DesignTokens.color.feedback.default.neutral_dark, '#2e2e2e'),
    color: applyColor(DesignTokens.color.icon.default.light, '#fff'),
    verticalAlign: 'middle',
    height: '23px',
    lineHeight: '21px',
    fontSize: '11px',
    padding: '0 22px',
});

cssRule('.tb-site-authentication .tb-outline-button', {
    lineHeight: '23px',
    marginRight: 0,
    marginLeft: 0,
});

cssRule('.tb-site-authentication .tb-group-name', {
    fontWeight: 'normal',
    fontSize: '15px',
    paddingBottom: '12px',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-site-authentication .tb-divider', {
    borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.medium, '#888'),
});

cssRule('.tb-site-authentication .tb-radio-button-group', {
    paddingBottom: '6px',
});

cssRule('.tb-site-authentication .tb-group-number', {
    marginRight: '12px',
});

cssRule('.tb-site-authentication .tb-group-content', {
    marginLeft: '35px',
    marginBottom: '12px',
});

cssRule('.tb-site-authentication .tb-group-content .tb-group-name', {
    marginTop: '12px',
});

cssRule('.tb-site-authentication .tb-auth-options-list table td.tb-auth-options-list-item', {
    paddingLeft: '5px',
});

cssRule('.tb-site-authentication .tb-dark-highlight', {
    fontWeight: 'bold',
});

cssRule('.tb-site-authentication .tb-disabled *', {
    color: applyColor(DesignTokens.color.font.default.secondary, '#5c5c5c') + ' !important',
});

cssRule('.tb-site-authentication table', {
    borderSpacing: 0,
});

cssRule('.tb-site-authentication .tb-label-padding', {
    paddingLeft: '123px',
});

cssRule('.tb-site-authentication .tb-auth-options-right-align', {
    textAlign: 'right',
    margin: '5px 0',
});

cssRule('.tb-site-authentication .tb-float-left', {
    float: 'left',
});

cssRule('.tb-site-authentication .tb-float-right', {
    float: 'right',
});

cssRule('.tb-site-authentication .tb-auth-options-label', {
    display: 'inline-block',
    textAlign: 'left',
    width: '123px',
    verticalAlign: 'middle',
});

cssRule('.tb-site-authentication .tb-url-holder', {
    padding: '2px',
    width: '520px',
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.default, '#eee'),
    border: '1px ' + applyColor(DesignTokens.color.elevation.border.default.medium, '#999')+' solid',
    color: applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
});

cssRule('.tb-site-authentication .tb-file-input', {
    marginRight: '12px',
    marginBottom: 0,
    flexGrow: 1,
});

cssRule('.tb-site-authentication .tb-file-input .tb-filename-label', {
    paddingRight: 0,
});

cssRule('.tb-site-authentication .tb-auth-options-left-margin', {
    marginLeft: '35px',
});

cssRule('.tb-site-authentication .tb-auth-assertions table', {
    border: '10px solid ' + applyColor(DesignTokens.color.component.border.neutral.default.default, '#eee'),
    borderCollapse: 'collapse',
    marginBottom: '10px',
    textAlign: 'left',
});

cssRule('.tb-site-authentication .tb-auth-assertions table td', {
    padding: '5px',
    width: '308.5px',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#eee'),
});

cssRule('.tb-site-authentication .tb-auth-assertions table td input[type=text], .tb-site-authentication .tb-auth-assertions table td select', {
    width: '100%',
});

cssRule('.tb-site-authentication .tb-auth-assertions table td.tb-auth-assertions-radio', {
    width: '185.5px',
    textAlign: 'right',
    paddingRight: '12px',
});

cssRule('.tb-site-authentication .tb-auth-assertions table td.tb-auth-assertions-radio .tb-radio-button', {
    display: 'inline-block',
});

cssRule('.tb-site-authentication .tb-auth-assertions table td.tb-auth-assertions-radio-label', {
    width: '120px',
});

cssRule('.tb-site-authentication .tb-auth-assertions table tr.tb-auth-assertion-grouping td', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
});

cssRule('.tb-site-authentication .tb-auth-table-header', {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-between',
    fontSize: '13px',
    fontWeight: 'bold',
});

cssRule('.tb-site-authentication .tb-auth-table-header-right', {
    marginLeft: 'auto',
});

cssRule('.tb-site-authentication .tb-users-link', {
    paddingRight: '12px',
    whiteSpace: 'nowrap',
});

cssRule('.tb-site-authentication .tb-form-indent', {
    marginLeft: '29px',
});

cssRule('.tb-site-authentication .tb-auth-options-row', {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '12px',
    marginTop: '3px',
});

cssRule('.tb-site-authentication .tb-auth-options-row .tb-align-right', {
    marginLeft: 'auto',
});

cssRule('.tb-site-authentication .tb-auth-options-row .tb-readonly-field', {
    flexGrow: 1,
});

cssRule('.tb-site-authentication .tb-readonly-field', {
    padding: '2px',
    border: '1px ' + applyColor(DesignTokens.color.elevation.border.default.medium, '#999')+' solid',
    color: applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, '#eee'),
});

cssRule('.tb-site-authentication .tb-filename-label', {
    width: '123px',
});

cssRule('.tb-site-authentication .tb-filename-display', {
    marginLeft: 0,
});

cssRule('.tb-dialog-body-template .tb-site-authentication', {
    overflowX: 'auto',
    overflowY: 'auto',
    width: '740px',
    maxHeight: '345px',
    paddingRight: '6px',
});

